import { Components, Theme } from '@mui/material/styles';

export const flowStep: Components<Theme>['MuiStep'] = {
  styleOverrides: {
    root: {
      // ensure content takes equal amount of space no matter content
      minWidth: '0',
    },
  },
};
